import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const UnstyledTTYToday = dynamic(() => import('./unstyled-tty-today'));

Builder.registerComponent(UnstyledTTYToday, {
  name: 'UnstyledTTYToday',
  noWrap: true,
});
